import React, { ReactElement } from "react";
import CorporateTopupHistoryList from "../../../components/Corporate/TopUp";
import Layout from "../../../components/layout";

const CorporateTopupHistoryPage = (): ReactElement => {
  return (
    <Layout>
      <CorporateTopupHistoryList />
    </Layout>
  );
};

export default CorporateTopupHistoryPage;
